import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "navbar custom-sticky-top py-2 pr-0 z-index-top" }
const _hoisted_2 = {
  class: "navbar-brand",
  href: "#"
}
const _hoisted_3 = { class: "head-title" }
const _hoisted_4 = { class: "dropdown" }
const _hoisted_5 = {
  class: "px-3 py-1",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_6 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_7 = { class: "ml-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-dark my-0" }, "Welcome,", -1)
const _hoisted_9 = { class: "text-muted font-weight-bold" }
const _hoisted_10 = {
  class: "dropdown-menu dropdown-menu-right bg-transparent py-0 border-0 z-index-top",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_11 = {
  class: "card shadow",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_12 = { class: "card-header rounded border-bottom border-primary" }
const _hoisted_13 = { class: "text-lead font-weight-bold" }
const _hoisted_14 = { class: "text-muted" }
const _hoisted_15 = { class: "text-primary" }
const _hoisted_16 = { class: "card-body px-0 py-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile_image = _resolveComponent("profile-image")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("a", _hoisted_2, [
      _renderSlot(_ctx.$slots, "toggleBtn"),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.organisation.name || "N/A"), 1)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_ctx.employee)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _createVNode(_component_profile_image, {
                    mode: "header",
                    "employee-id": _ctx.employee.id,
                    image: _ctx.employee.profileImage,
                    gender: _ctx.employee.gender
                  }, null, 8, ["employee-id", "image", "gender"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, _toDisplayString((_ctx.employee.firstName || "N/A") +
                " " +
                (_ctx.employee.lastName || "N/A")), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.employee.firstName ||
                  "N/A" + " " + (_ctx.employee.lastName || "N/A")), 1),
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.employee.jobTitle || "N/A"), 1),
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.employee.workEmail || "N/A"), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.profile()), ["prevent"])),
                class: "dropdown-item rounded nav-link text-primary",
                href: "#"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  class: "mr-1",
                  icon: "id-card"
                }),
                _createTextVNode(" Profile ")
              ]),
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.logOut()), ["prevent"])),
                class: "dropdown-item rounded nav-link text-danger",
                href: "#"
              }, [
                _createVNode(_component_font_awesome_icon, {
                  class: "mr-1",
                  icon: "power-off"
                }),
                _createTextVNode(" Log Out ")
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}